import ArgType from 'notebook/tables/excess/ArgType';
import FunctionCategory from 'notebook/tables/excess/FunctionCategory';

import {AnalysisFunction} from '../FunctionTypes';

export default {
  name: 'DATETRUNC',
  category: FunctionCategory.TIMESTAMP,
  description: 'Truncate date to specified time unit precision',
  shortDescription: 'Truncate date to specified precision',
  params: [
    {
      name: 'part',
      type: ArgType.text,
      description: 'The part of the date (example: "month").',
    },
    {
      name: 'date string',
      type: ArgType.text,
      description: 'The date to extract part from (example: "1992-03-02").',
    },
  ],
} satisfies AnalysisFunction;
